export { MediaQueryBreakpoints as default } from '@rockalingua/ui';
